import { compose, map, filter, includes } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getStringArrayProp, getStringProp } from '@mews/fp';
import { createAction } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { CashierAssignment } from '@mews-commander/data-access';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createScopedEntitiesReducer, createScopedBaseEntitySelectors } from './utils';

export const NAME = 'cashierAssignments';

const CASHIER_ASSIGNMENTS_UPDATED = prefix('CASHIER_ASSIGNMENTS_UPDATED');
const CASHIER_ASSIGNMENTS_DELETED = prefix('CASHIER_ASSIGNMENTS_DELETED');

export const [getCashierAssignments] = createScopedBaseEntitySelectors<
    ApplicationState,
    CashierAssignment,
    typeof NAME,
    'enterpriseId'
>(parentSelector, NAME, 'enterpriseId');

export const setCashierAssignments = (entities: CashierAssignment[], scope: string) =>
    createAction(CASHIER_ASSIGNMENTS_UPDATED, entities, { scope });
export const deleteCashierAssignmentsFromState = (ids: string[], scope: string) =>
    createAction(CASHIER_ASSIGNMENTS_DELETED, ids, { scope });

export const cashierAssignmentsReducer = createScopedEntitiesReducer({
    UPDATE_SUCCESS: CASHIER_ASSIGNMENTS_UPDATED,
    DELETE_SUCCESS: CASHIER_ASSIGNMENTS_DELETED,
});

const getEnterpriseProfileCashierAssignments = createSelector(
    getCashierAssignments,
    getStringProp('enterpriseProfileId'),
    (cashierAssignments, profileId) => filter<CashierAssignment>({ profileId })(cashierAssignments)
);

export const getEnterpriseProfileCashierIds = createSelector(getEnterpriseProfileCashierAssignments, map('cashierId'));

export const getEnterpriseProfileCashierAssignmentIdsByCashierIds = createSelector(
    getEnterpriseProfileCashierAssignments,
    getStringArrayProp('cashierIds'),
    (cashierAssignments, cashierIds) =>
        compose(
            map('id'),
            filter<CashierAssignment>(({ cashierId }) => includes(cashierId, cashierIds))
        )(cashierAssignments)
);
